module.exports = __webpack_public_path__ + "img/delivery.5d3fd272.png";